export default "__VITE_ASSET__BrR$iaGL__"